/**
 * View for configuring the agent assist settings as part of the KB creation wizard
 */
define([
  "marionette",
  "messaging/messenger",
  "./template/agentAssistSettingsTemplate.html",
], function (Marionette, Messenger, AgentAssistSettingsTemplate) {
  var AgentAssistSettingsView = {};

  AgentAssistSettingsView.agentAssistSettingsView = Marionette.ItemView.extend({
    template: AgentAssistSettingsTemplate,
    triggers: {
      "change #pcasVersion": "change:version",
    },
    getPcasLogonUrl: function () {
      return this.$el.find("#pcasLogonUrl").val();
    },
    getPcasUrl: function () {
      return this.$el.find("#pcasUrl").val();
    },
    getCompany: function () {
      return this.$el.find("#company").val();
    },
    getPcasUsername: function () {
      return this.$el.find("#pcasUsername").val();
    },
    getPcasPassword: function () {
      return this.$el.find("#pcasPassword").val();
    },
    getPcasUserAgent: function () {
      return this.$el.find("#pcasUserAgent").val();
    },
    getPcasVersion: function () {
      return this.$el.find("#pcasVersion").val();
    },
    pcasLogonUrlError: function (errorMessage) {
      this.$el
        .find("#pcasLogonUrlError")
        .append('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    pcasUrlError: function (errorMessage) {
      this.$el
        .find("#pcasUrlError")
        .append('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    companyError: function (errorMessage) {
      this.$el
        .find("#companyError")
        .append('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    pcasUsernameError: function (errorMessage) {
      this.$el
        .find("#pcasUsernameError")
        .append('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    pcasPasswordError: function (errorMessage) {
      this.$el
        .find("#pcasPasswordError")
        .append('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    pcasUserAgentError: function (errorMessage) {
      this.$el
        .find("#pcasUserAgentError")
        .append('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    clearErrors: function () {
      this.$el.find("#pcasLogonUrlError").html("");
      this.$el.find("#pcasUrlError").html("");
      this.$el.find("#companyError").html("");
      this.$el.find("#pcasUsernameError").html("");
      this.$el.find("#pcasPasswordError").html("");
      this.$el.find("#pcasUserAgentError").html("");
    },
    hidePcasLogonUrl: function () {
      this.$el.find("#pcasLogonUrlGroup").addClass("hidden");
    },
    showPcasLogonUrl: function () {
      this.$el.find("#pcasLogonUrlGroup").removeClass("hidden");
    },
  });

  return AgentAssistSettingsView;
});
